import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=f83d01dc&scoped=true&"
import script from "./Detail.vue?vue&type=script&lang=ts&"
export * from "./Detail.vue?vue&type=script&lang=ts&"
import style0 from "./Detail.vue?vue&type=style&index=0&id=f83d01dc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f83d01dc",
  null
  
)

export default component.exports